import { render, staticRenderFns } from "./reporterCollectionTable.vue?vue&type=template&id=32beb949&scoped=true"
import script from "./reporterCollectionTable.vue?vue&type=script&lang=ts"
export * from "./reporterCollectionTable.vue?vue&type=script&lang=ts"
import style0 from "./reporterCollectionTable.vue?vue&type=style&index=0&id=32beb949&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32beb949",
  null
  
)

export default component.exports